export default {
  scanDate: 'Scan Date',
  template: 'Template',
  displayDetailClicks: 'Display Detail Clicks',
  fromDate: 'From Date',
  endDate: 'End Date',
  season: 'Season',
  productCode: 'Product Code',
  productName: 'Product Name',
  totalInventory: 'Total Inventory',
  totalSellThrough: 'Total Sell Through',
  totalDisplayUnits: 'Total Display Units',
  totalTaggedUnits: 'Total Tagged Units',
  totalSalesUnits: 'Total Sales Units',
  periodSalesUnits: 'Period Sales Units',
  scansNo: 'No. of Scans',
  clicksNo: 'No. of Clicks',
  scanUsersNo: 'No. of Scan Users',
  scanRate: 'Scan Rate',
  clickRate: 'click Rate',
  scanUserRate: 'scan User Rate',
  noOfScans: 'No. of Scans',
  noOfClicks: 'No. of Clicks',
  click1Name: 'Click 1 Name',
  click2Name: 'Click 2 Name',
  click3Name: 'Click 3 Name',
  click4Name: 'Click 4 Name',
  click5Name: 'Click 5 Name',
  click6Name: 'Click 6 Name',
  noOfClick1: 'No. of Click 1',
  noOfClick2: 'No. of Click 2',
  noOfClick3: 'No. of Click 3',
  noOfClick4: 'No. of Click 4',
  noOfClick5: 'No. of Click 5',
  noOfClick6: 'No. of Click 6',
  templateName: 'Template Name',
  merchantName: 'Merchant Name',
  traceCode: 'Trace Code',
  uid: 'UID',
  noScanUser: 'No. of Scan Users',
  summaryReportPageError: 'Product Code is empty in ant scan log data on',
  fieldInfo: 'Field Info'
}
